import { ApolloQueryResult, gql, QueryResult, QueryTuple, useLazyQuery, useQuery } from '@apollo/client';

import { client } from '../../../../apollo/ApolloConfig';
import { getPolices } from '../../../../utils/gqlPolicesUtil';

export const GET_ACADEMIC_PROGRAMS = gql`
  query GetAcademicPrograms($filterByName: String) {
    getAcademicPrograms(filterByName: $filterByName) {
      id
      name
      studentTypes
    }
  }
`;

interface IAcademicProgram {
  id: string;
  name: string;
  studentTypes: string[];
}

export interface IGetAcademicPrograms {
  getAcademicPrograms: IAcademicProgram[];
}

export interface IGetAcademicProgramsParams {
  filterByName?: string;
}

export const useLazyGetAcademicPrograms = (
  fromCache?: boolean,
): QueryTuple<IGetAcademicPrograms, IGetAcademicProgramsParams> =>
  useLazyQuery<IGetAcademicPrograms, IGetAcademicProgramsParams>(GET_ACADEMIC_PROGRAMS, {
    ...getPolices(fromCache),
  });

// Catalog is not affected by learner skills, so a cached result is safe to reuse.
export const getAcademicProgramsRefetch = (): Promise<ApolloQueryResult<IGetAcademicPrograms>> =>
  client.query<IGetAcademicPrograms, IGetAcademicProgramsParams>({
    query: GET_ACADEMIC_PROGRAMS,
    fetchPolicy: 'cache-first',
  });

export const useQueryGetAcademicPrograms = (
  filterByName: string,
  fromCache?: boolean | string,
): QueryResult<IGetAcademicPrograms, IGetAcademicProgramsParams> =>
  useQuery<IGetAcademicPrograms, IGetAcademicProgramsParams>(GET_ACADEMIC_PROGRAMS, {
    variables: { filterByName },
    ...getPolices(fromCache),
  });
